import React from 'react';
import PaginationComponent from '../component/pagination.component';

const PaginationContainer = ({
    pages,
    handleChangeRowsPerPage,
    handleFirstPageButtonClick,
    handleBackButtonClick,
    handleNextButtonClick,
    handleLastPageButtonClick
}: any) => {
    return (
        <div>
            <PaginationComponent 
                pages={pages}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                handleFirstPageButtonClick={handleFirstPageButtonClick}
                handleBackButtonClick={handleBackButtonClick}
                handleNextButtonClick={handleNextButtonClick}
                handleLastPageButtonClick={handleLastPageButtonClick}
            />
        </div>
    );
};

export default PaginationContainer;